
export const IfDefined = ({value , children}: {value: any, children: any}) =>
    value !== undefined && value !== null ? children(value) : null;